import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetPatientProfileDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchPatientProfile = (patientId: string | null) => {
  const [getPatient, { data, loading }] = useLazyQuery(GetPatientProfileDocument);

  const patient = getNode(data, 'Patient');

  useEffect(() => {
    if (patientId) {
      getPatient({ variables: { patientId } });
    }
  }, [patientId, getPatient]);

  return { loading, patient };
};
